import { Activity } from "./activity";

export class Plan {
    id: string;
    name: string;
    duration: number = 0;
    activities: Activity[] = [];
    startTime: number;
    endTime: number;
    startTimeString: string;
    endTimeString: string;
    created: number;
    createdString: string;
    modified: number;
    modifiedString: string;
    path: string;
    uid: string = localStorage.getItem('uid');
}